// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/medication-and-drugs.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/medication-and-drugs/medication-and-drugs.js';

mount([g0]);
